export const getContentOrder = (index, rows, columns) => {
  const row = index % rows;
  const column = Math.floor(index / rows);
  return row * columns + column;
};
